// extracted by mini-css-extract-plugin
module.exports = {"PRHIVK":"PRHIVK_PRHIVK__4_FE1"};